import { render, staticRenderFns } from "./BadgeProdutosAtivos.vue?vue&type=template&id=4fbf998a&scoped=true"
import script from "./BadgeProdutosAtivos.vue?vue&type=script&lang=js"
export * from "./BadgeProdutosAtivos.vue?vue&type=script&lang=js"
import style0 from "./BadgeProdutosAtivos.vue?vue&type=style&index=0&id=4fbf998a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbf998a",
  null
  
)

export default component.exports